import { Toaster as SonnerToaster, ToasterProps } from 'sonner';

/**
 * ! This component is a wrapper around the sonner toaster component.
 * ! It should only be defined *once* in the app.
 */
export const Toaster = (props: ToasterProps) => {
  return (
    <SonnerToaster
      expand={true}
      gap={8}
      mobileOffset={16}
      offset={16}
      position='bottom-right'
      visibleToasts={5}
      {...props}
    />
  );
};
